import styled from 'styled-components';

export const CardWrapper = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 270px;
  min-width: 270px;
  border-radius: 16px;
  height: 258px;
  max-height: 258px;
  transition: 0.3s ease all;
  transform: scale(0.94);

  &.glide__slide--active {
    transform: scale(1);
  }

  &:hover {
    div {
      opacity: 1;
    }
  }
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  height: 0;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background: url(${p => p.url});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: 0;
  transition: 0.4s ease all;
  opacity: 0.9;
`;
